export default class IntelliProveAuthenticationError extends Error {
  constructor(msg?: string) {
    super(msg);
    Object.setPrototypeOf(this, IntelliProveAuthenticationError.prototype);
  }
}
